import React from 'react';
import PropTypes from 'prop-types';

import css from './FeatureArticlesFilter.module.scss';
import debounce from 'lodash/debounce';
import cn from 'classnames';

import DropdownFilter from 'components/DropdownFilter';

import RelatedArticles from 'components/RelatedArticles';

const DEBOUNCE_DURATION = 500;

class FeatureArticlesFilter extends React.Component {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired,
        years: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
            value: PropTypes.string
        })),
        yearsHeading: PropTypes.string,
        divisions: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
            value: PropTypes.string
        })),
        divisionsHeading: PropTypes.string,
        articleList: PropTypes.shape({
            blockId: PropTypes.number,
            articles: PropTypes.array,
            publishedLabel: PropTypes.string,
            showMoreButtonText: PropTypes.string
        }),
        initialDivision: PropTypes.number,
        language: PropTypes.string,
        rootPage: PropTypes.number,
        numberOfArticlesShown: PropTypes.number,
        numberOfArticlesToAdd: PropTypes.number
        
    }

    state = {
        year: undefined,
        division: this.props.initialDivision,
        articleList: this.props.articleList,
        language: this.props.language,
        rootPage: this.props.rootPage,
        searching: false,
        numberOfArticlesShown: this.props.numberOfArticlesShown,
        numberOfArticlesToAdd: this.props.numberOfArticlesToAdd,
        hasMoreArticles: false
    }

    showMoreArticles = () => {
        this.setState(state => ({numberOfArticlesShown: state.numberOfArticlesShown + this.state.numberOfArticlesToAdd}));
    }
    
    _yearFilter = (e, value) => {
        this.setState({
            year: value ? value : undefined
        }, this._debouncedFilterItems);
    }
    _divisionFilter = (e, value) => {
        this.setState({
            division: value
        }, this._debouncedFilterItems);
    }

    _filterItems = () => {
        const filter = { ...this.state };

        const search = () => {
            window.fetch(this.props.apiUrl, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                method: 'POST',
                body: JSON.stringify(filter)
            }).then(res => {
                if (!res.ok) {
                    this.setState({
                        searching: false,
                    });

                    return console.error(res);
                }

                res.json().then(json => {
                    this.setState({
                        articleList: json,
                        searching: false,
                    });
                });
            }).catch(err => {
                console.error(err);

                this.setState({
                    searching: false,
                });
            });
        };

        this.setState({
            searching: true,
        }, search);
    }

    _debouncedFilterItems = debounce(this._filterItems, DEBOUNCE_DURATION)

    render() {
        const {
            years,
            yearsHeading,
            divisions,
            divisionsHeading
        
        } = this.props;

        const {
            articleList,
            division,
            numberOfArticlesShown
           
        } = this.state;

        const articlesToShow = <RelatedArticles {...articleList} hasMoreArticles={this.state.numberOfArticlesShown >= articleList.articles.length ? false : true} showMoreArticles={this.showMoreArticles} articles={articleList.articles.slice(0, numberOfArticlesShown).map((item) => {
            return {
                ...item
            };
        })} keys={["date", "title", "division"]}/>;

        return (
            <div className={css.block}>
                    <div className={css.filters}>
                        <ul>
                            <li>
                                <DropdownFilter heading={yearsHeading} items={years} onSelect={this._yearFilter} />
                            </li>
                            <li>
                                <DropdownFilter active={division} heading={divisionsHeading} items={divisions} onSelect={this._divisionFilter} />
                            </li>
                        </ul>
                </div>
                <div className={css["list-outer"]}>
                    <div className={cn(css.list, {
                        [css.searching]: this.state.searching
                    })}>
                        {articlesToShow}
                    </div>
                </div>
     
            </div>
        );
    }
}

export default FeatureArticlesFilter;



// WEBPACK FOOTER //
// ./src/components/FeatureArticlesFilter/FeatureArticlesFilter.jsx